/* eslint-disable */
import api from '@/services/api';

export default {
  async fetchPortos({ commit }) {
    const { data: portos } = await api.get('/tracking/portos/listarPortos');
    commit('SET_PORTOS', portos);
  },

  async fetchProcessosPorto({}, payload) {
    return await api.get(`/tracking/portos/processosPorto/${payload}`);
  },
};
